import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <section className="py-20 bg-navy">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-white mb-6">
            Ready to Get Your Documents Notarized?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto font-body leading-relaxed">
            Schedule your mobile notary appointment today. Fast, professional, and convenient service that comes to you.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a 
              href="/contact"
              className="px-8 py-4 bg-teal text-white rounded-lg font-semibold text-base hover:bg-teal/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Schedule Now
            </a>
            <a 
              href="tel:+1234567890"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-lg font-semibold text-base hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              Call Us
            </a>
          </div>
          <p className="text-sm text-white/70 mt-8 font-body">
            Questions about what documents you need or pricing? We're here to help—reach out anytime.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
